
    import * as React from 'react';

    const ShoppingBag16 = ({ color = 'currentcolor', height = '16px', width = '16px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 16 16" style={svgStyle}><path d="M5 6V3.8C5 2.254 6.343 1 8 1s3 1.254 3 2.8V6h4v9H1V6h4zm.75 0h4.5V3.8c0-1.16-1.007-2.1-2.25-2.1s-2.25.94-2.25 2.1V6zM5 6.692H1.7v7.616H5V6.692zm.75 0V14.3h4.5V6.692h-4.5zm5.25 0v7.616h3.3V6.692H11z" /></svg>
        </div>
      );
    };

    ShoppingBag16.displayName = 'ShoppingBag16';

    export default ShoppingBag16;
  